import { inject } from 'inversify';

import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { CreateCountryErrorsMapper, CreateCountryMapper } from '../mappers';
import { CreateCountryDto } from '../dtos';

export type ICreateCountryRepoResponse = IRepoResponse<200> | IRepoResponse<400, object> | IRepoResponse<422 | 500, string>;

export type ICreateCountryRepo = IRepo<[CreateCountryDto, string | number | undefined], ICreateCountryRepoResponse>;

export const CreateCountryRepoType = Symbol.for('CreateCountryRepo');

@bind(CreateCountryRepoType)
export class CreateCountryRepo implements ICreateCountryRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(dto: CreateCountryDto) {
    try {
      const body = new FormData();

      appendToFormData(CreateCountryMapper.toPersistence(dto), body);

      const url = dto.countryId ? urlMaker('/api/admin/countries/edit') : urlMaker('/api/admin/countries/create');

      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 400) {
        const errors = CreateCountryErrorsMapper.toDomain(result.data.errors);

        return {
          status: 400 as 400,
          response: errors,
        };
      } else {
        return {
          status: 422 as 422,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      console.error(e);
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
